import { render, staticRenderFns } from "./pay_pending.vue?vue&type=template&id=24dcc02e&scoped=true"
import script from "./pay_pending.vue?vue&type=script&lang=js"
export * from "./pay_pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcc02e",
  null
  
)

export default component.exports